import { createTheme } from "@mui/material";

export const dark = createTheme({
  palette: {
    mode: "dark",
    // primary: {
    //   main: "#e75480",
    //   dark: "#e75480",
    // },
    // secondary: {
    //   main: "#e75480",
    // },
    text: {
      primary: "#eee",
    },
    background: {
      // default: "black",
      // paper: "black",
      paper: "rgb(36 35 35 / 96%)" /* !XMAS <- transparency for xmas theme, was -> paper: "#242323" */,
      // paper: "#242323",
    },
  },
});

export const amoled = createTheme({
  palette: {
    mode: "dark",
    text: { primary: "#eee" },
    background: {
      default: "black",
      paper: "black",
    },
  },
});

// export const light = createTheme({
//   palette: {
//     mode: "light",
//   },
// });
